// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1vSdT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _link = require("@react-spectrum/s2/Link");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
    onPress: ()=>alert('Pressed link'),
    children: "Link"
});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2/Link":"42COX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _link = require("react-aria-components/Link");
var _skeleton = require("./Skeleton");
var _useDOMRef = require("./useDOMRef");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf171';
    else rules += ' _Le171';
    if (props.isStaticColor) rules += ' Oe171';
    else rules += ' Oh171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' _Mc171';
    rules += ' _Kd171';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr171';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s171';
    rules += ' oR3ltQc171';
    rules += ' nR3ltQc171';
    rules += ' kR3ltQc171';
    rules += ' jR3ltQc171';
    if (props.isStandalone) {
        rules += ' uk171';
        rules += ' ucJ9TBTb171';
        rules += ' ud3Euai171';
        rules += ' uea171';
        rules += ' ugb171';
        rules += ' uhd171';
        rules += ' uje171';
        rules += ' u2NhKxcl171';
        rules += ' uic171';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c171';
        rules += ' vFHT6Dd171';
    }
    if (props.isStandalone) {
        rules += ' xc171';
        rules += ' _xa171';
    }
    if (props.isStandalone) {
        rules += ' _Fd171';
        rules += ' _FnuYUweb171';
    }
    if (props.isStaticColor) rules += ' pl171';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po171';
        else if (props.isFocusVisible) rules += ' po171';
        else if (props.isHovered) rules += ' po171';
        else rules += ' pt171';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps171';
        else if (props.isFocusVisible) rules += ' ps171';
        else if (props.isHovered) rules += ' ps171';
        else rules += ' pu171';
    }
    rules += ' plOVIhfcA5Qiqd171';
    rules += ' plOVIhfcA5Qiqd171';
    rules += ' Yd171';
    rules += ' Xb171';
    rules += ' _2b171';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb171';
                rules += ' __Va171';
            } else if (props.isHovered) {
                rules += ' _Xb171';
                rules += ' __Va171';
            } else rules += ' _Xa171';
        }
    } else {
        rules += ' _Xb171';
        rules += ' __Va171';
    }
    rules += ' __ca171';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _useDOMRef.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components/Link":"fOCdV","./Skeleton":"1mUnF","./useDOMRef":"9tqah","react-aria/private/utils/useLayoutEffect":"k6VV7","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _slots = require("react-aria-components/slots");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _icon = require("./Icon");
var _text = require("react-aria-components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _useDOMRef = require("./useDOMRef");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk171';
        rules += ' ucJ9TBTb171';
        rules += ' ud3Euai171';
        rules += ' uea171';
        rules += ' ugb171';
        rules += ' uhd171';
        rules += ' uje171';
        rules += ' u2NhKxcl171';
        rules += ' uic171';
    } else if (props.size === "L") {
        rules += ' uk171';
        rules += ' ucJ9TBTb171';
        rules += ' ud3Euai171';
        rules += ' uea171';
        rules += ' ugb171';
        rules += ' uhd171';
        rules += ' uje171';
        rules += ' u2NhKxcl171';
        rules += ' uic171';
    } else if (props.size === "S") {
        rules += ' uk171';
        rules += ' ucJ9TBTb171';
        rules += ' ud3Euai171';
        rules += ' uea171';
        rules += ' ugb171';
        rules += ' uhd171';
        rules += ' uje171';
        rules += ' u2NhKxcl171';
        rules += ' uic171';
    } else if (props.size === "XS") {
        rules += ' uk171';
        rules += ' ucJ9TBTb171';
        rules += ' ud3Euai171';
        rules += ' uea171';
        rules += ' ugb171';
        rules += ' uhd171';
        rules += ' uje171';
        rules += ' u2NhKxcl171';
        rules += ' uic171';
    } else {
        rules += ' uk171';
        rules += ' ucJ9TBTb171';
        rules += ' ud3Euai171';
        rules += ' uea171';
        rules += ' ugb171';
        rules += ' uhd171';
        rules += ' uje171';
        rules += ' u2NhKxcl171';
        rules += ' uic171';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e171';
        rules += ' vFHT6Dd171';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d171';
        rules += ' vFHT6Dd171';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b171';
        rules += ' vFHT6Dd171';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a171';
        rules += ' vFHT6Dd171';
    } else {
        rules += ' -_6BNtrc-c171';
        rules += ' vFHT6Dd171';
    }
    if (props.size === "XL") {
        rules += ' xb171';
        rules += ' _xa171';
    } else if (props.size === "L") {
        rules += ' xb171';
        rules += ' _xa171';
    } else if (props.size === "S") {
        rules += ' xb171';
        rules += ' _xa171';
    } else if (props.size === "XS") {
        rules += ' xb171';
        rules += ' _xa171';
    } else {
        rules += ' xb171';
        rules += ' _xa171';
    }
    if (props.size === "XL") {
        rules += ' _Fd171';
        rules += ' _FnuYUweb171';
    } else if (props.size === "L") {
        rules += ' _Fd171';
        rules += ' _FnuYUweb171';
    } else if (props.size === "S") {
        rules += ' _Fd171';
        rules += ' _FnuYUweb171';
    } else if (props.size === "XS") {
        rules += ' _Fd171';
        rules += ' _FnuYUweb171';
    } else {
        rules += ' _Fd171';
        rules += ' _FnuYUweb171';
    }
    if (props.fillStyle === "outline") rules += ' pm171';
    else if (props.fillStyle === "subtle") rules += ' pm171';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg171';
        else if (props.variant === "chartreuse") rules += ' pg171';
        else if (props.variant === "yellow") rules += ' pg171';
        else if (props.variant === "orange") rules += ' pg171';
        else if (props.variant === "notice") rules += ' pg171';
        else rules += ' px171';
    }
    rules += ' sd171';
    rules += ' ea171';
    rules += ' egLWx3bb171';
    rules += ' _oa171';
    rules += ' Sv171';
    rules += ' SgLWx3bd171';
    rules += ' Rv171';
    rules += ' RgLWx3bd171';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc171';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG171';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c171';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc171';
    } else if (!minWidth) rules += ' N4dY0ec171';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec171';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn171';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b171';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd171';
    else rules += ' -SFnbic-_Jb171';
    rules += ' -Bu7z1c-oH5kTnc171';
    rules += ' oj171';
    rules += ' nj171';
    rules += ' kj171';
    rules += ' jj171';
    rules += ' qc171';
    rules += ' qsd171';
    rules += ' -Qg41Lb-IAxCW0c171';
    rules += ' -Qg41Lb-gLWx3bIYB8I171';
    rules += ' MAyFGYc171';
    rules += ' Td171';
    rules += ' Qd171';
    rules += ' -aRvJDd-Tu7Fubd171';
    rules += ' _Ca171';
    if (props.fillStyle === "outline") rules += ' g_g171';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f171';
        else if (props.variant === "cinnamon") rules += ' gP171';
        else if (props.variant === "brown") rules += ' gO171';
        else if (props.variant === "turquoise") rules += ' gy171';
        else if (props.variant === "pink") rules += ' gT171';
        else if (props.variant === "magenta") rules += ' gS171';
        else if (props.variant === "fuchsia") rules += ' gR171';
        else if (props.variant === "purple") rules += ' gM171';
        else if (props.variant === "indigo") rules += ' gK171';
        else if (props.variant === "blue") rules += ' gG171';
        else if (props.variant === "cyan") rules += ' gC171';
        else if (props.variant === "seafoam") rules += ' gz171';
        else if (props.variant === "green") rules += ' gA171';
        else if (props.variant === "celery") rules += ' gv171';
        else if (props.variant === "chartreuse") rules += ' gJ171';
        else if (props.variant === "yellow") rules += ' gW171';
        else if (props.variant === "orange") rules += ' gV171';
        else if (props.variant === "red") rules += ' gU171';
        else if (props.variant === "gray") rules += ' gI171';
        else if (props.variant === "negative") rules += ' gU171';
        else if (props.variant === "notice") rules += ' gV171';
        else if (props.variant === "positive") rules += ' gA171';
        else if (props.variant === "neutral") rules += ' gI171';
        else if (props.variant === "informative") rules += ' gG171';
        else if (props.variant === "accent") rules += ' gG171';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm171';
        else if (props.variant === "cinnamon") rules += ' gq171';
        else if (props.variant === "brown") rules += ' gn171';
        else if (props.variant === "turquoise") rules += ' g5171';
        else if (props.variant === "pink") rules += ' gx171';
        else if (props.variant === "magenta") rules += ' gD171';
        else if (props.variant === "fuchsia") rules += ' gr171';
        else if (props.variant === "purple") rules += ' go171';
        else if (props.variant === "indigo") rules += ' gl171';
        else if (props.variant === "blue") rules += ' g2171';
        else if (props.variant === "cyan") rules += ' gk171';
        else if (props.variant === "seafoam") rules += ' g4171';
        else if (props.variant === "green") rules += ' g1171';
        else if (props.variant === "celery") rules += ' g7171';
        else if (props.variant === "chartreuse") rules += ' gp171';
        else if (props.variant === "yellow") rules += ' gN171';
        else if (props.variant === "orange") rules += ' gQ171';
        else if (props.variant === "red") rules += ' gB171';
        else if (props.variant === "gray") rules += ' g6171';
        else if (props.variant === "negative") rules += ' gB171';
        else if (props.variant === "notice") rules += ' gQ171';
        else if (props.variant === "positive") rules += ' g1171';
        else if (props.variant === "neutral") rules += ' g6171';
        else if (props.variant === "informative") rules += ' g2171';
        else if (props.variant === "accent") rules += ' g2171';
    }
    rules += ' _jf171';
    rules += ' _kJ8iPYd171';
    rules += ' hXMFGYc171';
    rules += ' mc171';
    rules += ' lc171';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS171';
        else if (props.variant === "notice") rules += ' i9VrKkd171';
        else if (props.variant === "positive") rules += ' ip17Jm171';
        else if (props.variant === "neutral") rules += ' i0ruhAb171';
        else if (props.variant === "informative") rules += ' iG1ze4d171';
        else if (props.variant === "accent") rules += ' iG1ze4d171';
        else rules += ' iA171';
    } else rules += ' iA171';
    rules += ' -_8sjo0b-t5ZbAob171';
    if (props.size === "XL") rules += ' -M_-MBaYFfc171';
    else if (props.size === "L") rules += ' -M_-M3JjxG171';
    else if (props.size === "S") rules += ' -M_-MCe2o8c171';
    else if (props.size === "XS") rules += ' -M_-MifsFYc171';
    else rules += ' -M_-M4dY0ec171';
    rules += ' -_k_-_kc171';
    rules += ' -h_-hc171';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG171';
                        rules += ' QAzEcG171';
                        rules += ' _Jb171';
                        rules += ' _Nc171';
                        rules += ' Pc171';
                        rules += ' _Yb171';
                        if (props.overflowMode === "wrap") rules += ' _7b171';
                        else if (props.overflowMode === "truncate") rules += ' _7c171';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _text.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja171"
                    }),
                    styles: " ZObNfn171 FObNfn171 I67logd171 _va171"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _filterDOMProps.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components/slots":"bA6Cz","react-aria/filterDOMProps":"c0Owd","./Icon":"jQAJE","react-aria-components/Text":"jt9fm","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","./useDOMRef":"9tqah","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"6hpGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M9.223 13.5c-.212 0-.415-.09-.558-.248l-2.51-2.792c-.278-.309-.253-.782.055-1.06s.781-.252 1.06.056l1.893 2.107 3.487-4.756c.244-.334.711-.41 1.048-.161.334.244.406.713.161 1.047l-4.032 5.5c-.133.183-.342.295-.567.306z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hYP4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _reactAriaLogo = require("./icons/ReactAriaLogo");
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    }
};

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=Link.cae4f899.js.map
